import unauthenticatedHttp from "@/services/unauthenticatedHttp";

export async function fetchChallenge(id: any) {
  const { data } = await unauthenticatedHttp().get(
    `${window.env.API_UNAUTH}/courses/${id}`
  );

  return data;
}
